export const GridBackground = () => (
  <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-obsidian">
    <div
      className="absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage:
          "linear-gradient(to right, #1E293B 1px, transparent 1px), linear-gradient(to bottom, #1E293B 1px, transparent 1px)",
        backgroundSize: "44px 44px",
      }}
    />
    <div className="absolute -top-40 left-1/4 h-[420px] w-[420px] rounded-full bg-electric/20 blur-[120px]" />
    <div className="absolute top-[60%] right-0 h-[380px] w-[380px] rounded-full bg-laser/10 blur-[130px]" />
    <div className="absolute bottom-0 left-0 h-[300px] w-[300px] rounded-full bg-electric/10 blur-[120px]" />
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-obsidian/40 to-obsidian" />
  </div>
);
